"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImageUrl = exports.isDocument = exports.isGuideEmbedObject = exports.isGuideVideoObject = exports.isGuideImage = exports.isNotUploadingMediaItem = exports.isUploadingMediaItem = void 0;
function isUploadingMediaItem(item) {
    return item.type === 'Uploading';
}
exports.isUploadingMediaItem = isUploadingMediaItem;
function isNotUploadingMediaItem(item) {
    return item.type !== 'Uploading';
}
exports.isNotUploadingMediaItem = isNotUploadingMediaItem;
function isGuideImage(item) {
    return item.type === 'GuideImage';
}
exports.isGuideImage = isGuideImage;
function isGuideVideoObject(item) {
    return item.type === 'GuideVideoObject';
}
exports.isGuideVideoObject = isGuideVideoObject;
function isGuideEmbedObject(item) {
    return item.type === 'GuideEmbedObject';
}
exports.isGuideEmbedObject = isGuideEmbedObject;
function isDocument(item) {
    return item.type === 'Document';
}
exports.isDocument = isDocument;
var imageExtensions = ['jpeg', 'jpg', 'gif', 'png', 'bmp', 'tiff', 'tif'];
// This implementation is copied from an older implementation from the dozuki-monolith
function isImageUrl(url) {
    var re = new RegExp(imageExtensions.join('|'));
    var isImageUrl = url.match(re);
    return isImageUrl;
}
exports.isImageUrl = isImageUrl;
